/**
 * Helpers for Klarna On-site messaging (Web SDK / Klarna OSM app).
 * @see https://docs.klarna.com/acquirer/klarna/on-site-messaging/additional-resources/placements/
 */
(() => {
  const refresh = () => {
    window.Klarna?.OnsiteMessaging?.refresh?.();
  };

  const updatePurchaseAmount = (selector, cents) => {
    const placement = document.querySelector(selector);
    if (!placement || cents == null) return;
    placement.setAttribute('data-purchase-amount', String(Math.round(cents)));
    refresh();
  };

  const refreshWhenReady = (attempts = 0) => {
    if (window.Klarna?.OnsiteMessaging) {
      refresh();
      return;
    }
    if (attempts < 40) {
      window.setTimeout(() => refreshWhenReady(attempts + 1), 250);
    }
  };

  window.BuxiboKlarnaOsm = { refresh, updatePurchaseAmount };

  if (document.querySelector('klarna-placement')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => refreshWhenReady());
    } else {
      refreshWhenReady();
    }
  }
})();
